<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="姓名" name="realName">
                <a-input v-model:value="searchForm.realName" placeholder="请输入姓名" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined />
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #major="{ text }">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['education_major']" :text="text"></dict-render>
                </a-tag>
            </template>
            <template #sex="{ text }">
                <span v-if="text == 0">男</span>
                <span v-if="text == 1">女</span>
            </template>
            <template #edu="{ text }">
                <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
            </template>
            <template #talentTitle="{ text }">
                <dict-render :dict-obj="dictObjs['hope_job']" :text="text"></dict-render>
            </template>
            <template #action="{ record }">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import { dictMixin, tableListMixin } from "@/mixins";
import { talentApi } from "@/api/companyService";
import DictRender from "@/components/other/DictRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    { title: "姓名", dataIndex: "realName", key: "realName" },
    { title: "性别", dataIndex: "sex", key: "sex", slots: { customRender: "sex" } },
    { title: '学历', dataIndex: "edu", key: "edu", slots: { customRender: "edu" } },
    { title: "毕业院校", dataIndex: "graduationUniversity", key: "graduationUniversity", ellipsis: 'true' },
    { title: "职务", dataIndex: "position", key: "position" },
    { title: "所学专业", dataIndex: "major", key: "major", slots: { customRender: "major" } },
    { title: "从业年限", dataIndex: "workingSeniority", key: "workingSeniority" },
    { title: '职位/职务', dataIndex: "talentTitle", key: "talentTitle", slots: { customRender: "talentTitle" } },
    { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        AddOrEditModal,
        DictRender
    },
    data() {
        return {
            dictNames: 'education_major,education_background,hope_job',
            columns,
            queryParamFixed: { companyCode: this.$ls.get('companyCode') },
            listUrl: talentApi.pageList,
            listKeyField: "id",
            deleteUrl: talentApi.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: talentApi.detail,
                params: { id: record.id }
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },

    }
}
</script>

<style scoped></style>
